var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.4001 2.39999C2.61227 2.39999 2.81575 2.48428 2.96578 2.63431C3.11581 2.78434 3.2001 2.98782 3.2001 3.19999V12.8C3.2001 13.0122 3.11581 13.2157 2.96578 13.3657C2.81575 13.5157 2.61227 13.6 2.4001 13.6C2.18792 13.6 1.98444 13.5157 1.83441 13.3657C1.68438 13.2157 1.6001 13.0122 1.6001 12.8V3.19999C1.6001 2.98782 1.68438 2.78434 1.83441 2.63431C1.98444 2.48428 2.18792 2.39999 2.4001 2.39999ZM8.5657 5.03439C8.71567 5.18442 8.79993 5.38786 8.79993 5.59999C8.79993 5.81213 8.71567 6.01557 8.5657 6.16559L7.5313 7.19999H13.6001C13.8123 7.19999 14.0158 7.28428 14.1658 7.43431C14.3158 7.58434 14.4001 7.78782 14.4001 7.99999C14.4001 8.21217 14.3158 8.41565 14.1658 8.56568C14.0158 8.71571 13.8123 8.79999 13.6001 8.79999H7.5313L8.5657 9.83439C8.71142 9.98528 8.79206 10.1874 8.79024 10.3971C8.78841 10.6069 8.70428 10.8075 8.55595 10.9558C8.40763 11.1042 8.20698 11.1883 7.99722 11.1901C7.78746 11.192 7.58538 11.1113 7.4345 10.9656L5.0345 8.56559C4.88452 8.41557 4.80027 8.21213 4.80027 7.99999C4.80027 7.78786 4.88452 7.58442 5.0345 7.43439L7.4345 5.03439C7.58452 4.88442 7.78797 4.80016 8.0001 4.80016C8.21223 4.80016 8.41568 4.88442 8.5657 5.03439Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.cdd72f2e96125fc3182ebe59aab1ef13.svg";
export { ForwardRef as ReactComponent };